module.exports = __webpack_public_path__ + "img/Chatapp4.9ba1ac08.jpg";